export function callToInteviewValidate(payload) {
  return !!(
    payload.candidate
    && payload.opportunity
    && payload.company
    && payload.whitelabel
  )
}
